
	import _ from "lodash";
	import { abstractField } from "vue-form-generator";

	export default {
		mixins: [ abstractField ],
	}
